import {
  Component,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ButtonComponent } from '../../../feedback/button/button.component';
import {
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { FormInputComponent } from '../form-input.component';
import { NgStyle, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'aw-drag-drop',
  templateUrl: './drop-zone.component.html',
  styles: '',
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    AppendTestIdPipe,
    ErrorMessageComponent,
    NgStyle,
    NgTemplateOutlet,
  ],
})
export class DropZoneComponent
  extends FormInputComponent
  implements OnInit, OnDestroy
{
  public description: InputSignal<string> = input<string>(
    'Per Drag-and-Drop können Dateien angehangen werden oder über'
  );
  public filesChosen: InputSignal<string> = input<string>(
    'Dateien ausgewählt.'
  );
  public override label: InputSignal<string | undefined> = input<
    string | undefined
  >('Datei auswählen');

  public isMultiple: InputSignal<boolean> = input.required();
  public allowedFileTypes: InputSignal<string[]> = input.required();
  public fileType: InputSignal<string> = input.required();

  ngOnInit() {
    this.ngControl.control?.addValidators(
      this.conformsToFileType(this.ngControl.control?.value)
    );
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.ngControl.control?.removeValidators(
      this.conformsToFileType(this.ngControl.control?.value)
    );
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      this.selectFiles(Array.from(event.dataTransfer?.files));
    }
  }

  public selectFilesEvent($event: Event): void {
    const target = $event.target as HTMLInputElement;
    const files = target.files as FileList;
    if (this.isMultiple()) {
      this.selectFiles(Array.from(files));
    } else {
      this.selectFiles(files.length > 0 ? [files.item(0) as File] : []);
    }
  }

  public selectFiles(files: File[]): void {
    if (files && files.length > 0) {
      if (this.isMultiple()) {
        this.ngControl.control?.setValue(files);
      } else {
        this.ngControl.control?.setValue([files[0]]);
      }
      this.ngControl.control?.updateValueAndValidity();
    }
  }

  private conformsToFileType(files: File[]): ValidatorFn {
    return (): ValidationErrors | null => {
      let checkFileType = false;

      files?.forEach(file => {
        if (file) {
          const nameExtension = file.name.split('.').pop();

          const allowedTypes = this.allowedFileTypes();
          const allowedTypesLong = allowedTypes.map(
            allowedType => `${this.fileType()}/${allowedType}`
          );

          if (nameExtension && !allowedTypes.includes(nameExtension)) {
            checkFileType = true;
          }
          if (file.type !== '' && !allowedTypesLong.includes(file.type)) {
            checkFileType = true;
          }
        }
      });

      return checkFileType ? { wrongFileType: true } : null;
    };
  }
}
